import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Text,
  TextWithLinks,
} from 'ui_2';

type Props = {
  termsAndConditions: string;
};
export const ProductTermsAndConditions = ({ termsAndConditions }: Props) => {
  return (
    <Accordion type='single' collapsible>
      <AccordionItem value='termsAndConditions'>
        <AccordionTrigger>
          <Text font='medium-sm'>Terms and Conditions</Text>
        </AccordionTrigger>
        <AccordionContent>
          <TextWithLinks
            font='sm'
            linkTarget='_blank'
            text={termsAndConditions}
          />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
